import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import { Button, TextArea, Input } from "components";
import { CloseIcon, ConfirmSuccessIcon, ConfirmFailIcon } from "icons";
import {
  SendFullStressNotiActionCreators,
  SendMiniStressNotiActionCreators,
  SendHighStressNotiActionCreators,
} from "redux/rootActions";
import {
  sendFullStressNotificationDataResponse,
  selectFullStressNotiErrorMessage,
  selectIsLoadingFullStressNoti,
} from "redux/stressCheck/fullStressSendNoti/fullStressSendNotiStates";
import {
  sendMiniStressNotificationDataResponse,
  selectMiniStressNotiErrorMessage,
  selectIsLoadingMiniStress,
} from "redux/stressCheck/miniStressSendNoti/miniStressSendNotiStates";
import {
  sendHighStressNotificationDataResponse,
  selectHighStressErrorMessage,
  selectIsLoadingHighStress,
} from "redux/stressCheck/sendHighStressNoti/sendHighStressNotiStates";
import { httpStatus } from "configs/httpStatus";

import {
  Text,
  ConfirmContainer,
  TextConfirm,
  ButtonContainer,
  SectionContainer,
  Label,
  BadgeContainer,
  ConfirmModalStyled,
  ConfirmBtnStyled,
  FailText,
  WrapperSendMessageBtn,
  SendMessageModalStyled,
} from "screens/messageDelivery/MessageDelivery.style";
import { TagsContainer, WrapperBtnForm } from "./Stress.style";
import { ConfirmModal } from "./components";

interface IConfirmInterviewModal {
  label: string;
  isVisible: boolean;
  handleCancel: () => void;
  checkBoxList: any;
  setCheckBoxList: any;
  isFullStress: boolean;
  isHighStress: boolean;
  isSendAll: boolean;
  setIsRemindAll: any;
}

const schema = yup.object().shape({
  message_title: yup.string().trim().required("message-title-required"),
  message: yup.string().required("message-required"),
});

const ConfirmInterviewModal: React.FC<IConfirmInterviewModal> = ({
  isVisible,
  handleCancel,
  label,
  checkBoxList,
  setCheckBoxList,
  isFullStress,
  isHighStress,
  isSendAll,
  setIsRemindAll,
}) => {
  const { t }: any = useTranslation("translation", {
    keyPrefix: "message-delivery",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });
  const { t: t2 }: any = useTranslation("translation", {
    keyPrefix: "stress-check",
  });

  const { handleSubmit, control, watch, setValue } = useForm({
    resolver: yupResolver(schema),
  });
  const dispatch = useDispatch();
  const sendFullStressNotificationData = useSelector(
    sendFullStressNotificationDataResponse
  );
  const sendMiniStressNotificationData = useSelector(
    sendMiniStressNotificationDataResponse
  );
  const sendHighStressNotificationData = useSelector(
    sendHighStressNotificationDataResponse
  );
  const sendFullStressNotificationError = useSelector(
    selectFullStressNotiErrorMessage
  );
  const sendMiniStressNotificationError = useSelector(
    selectMiniStressNotiErrorMessage
  );
  const sendHighStressNotificationError = useSelector(
    selectHighStressErrorMessage
  );

  const isLoadingFullStressNoti = useSelector(selectIsLoadingFullStressNoti);
  const isLoadingMiniStressNoti = useSelector(selectIsLoadingMiniStress);
  const isLoadingHighStressNoti = useSelector(selectIsLoadingHighStress);

  const [isVisibleNotification, setIsVisibleNotification] = useState({
    type: "",
    status: false,
  });

  const watchmessageTitle = watch("message_title");
  const watchmessage = watch("message");

  const handleCancelSendMessageModal = () => {
    handleCancel();
  };

  const handleConfirmMessage = () => {
    setIsVisibleNotification({
      ...isVisibleNotification,
      type: "success",
      status: true,
    });
  };

  const handleFailMessage = () => {
    setIsVisibleNotification({
      ...isVisibleNotification,
      type: "fail",
      status: true,
    });
  };

  const handleCancelNotication = () => {
    setIsVisibleNotification({ type: "", status: false });
    dispatch(SendFullStressNotiActionCreators.handleResetDataAction());
    dispatch(SendMiniStressNotiActionCreators.handleResetDataAction());
    dispatch(SendHighStressNotiActionCreators.handleResetDataAction());
    handleCancelSendMessageModal();
  };

  const hanelGetParams = () => {
    return {
      short_text: watchmessageTitle,
      notification_text: watchmessage,
      user_ids: checkBoxList
        ?.map((uif: any) => {
          return uif.user_id;
        })
        .join(","),
    };
  };

  const onSendStressReminder = () => {
    const params = hanelGetParams();

    if (isFullStress) {
      dispatch(
        SendFullStressNotiActionCreators.sendFullStressNotificationAction(
          params
        )
      );
    } else {
      dispatch(
        SendMiniStressNotiActionCreators.sendMiniStressNotificationAction(
          params
        )
      );
    }
  };

  const onSendHighStressNotification = () => {
    const params = hanelGetParams();

    dispatch(
      SendHighStressNotiActionCreators.sendHighStressNotificationAction(params)
    );
  };

  useEffect(() => {
    setValue(
      "message_title",
      "【Quan trọng】Bạn có một tin nhắn từ Bác sĩ y tế doanh nghiệp"
    );
    setValue(
      "message",
      "Dựa trên kết quả kiểm tra mức độ căng thẳng, chúng tôi xin gửi thông báo đến những cá nhân được đánh giá là “có mức độ căng thẳng cao”. Bạn có mong muốn được trao đổi trực tiếp với Bác sĩ y tế doanh nghiệp không?\n※Trường hợp bác sĩ nhận thấy có lý do chính đáng để bảo vệ sức khỏe của bạn, một phần nội dung buổi trao đổi có thể được báo cáo đến người sử dụng lao động. Nếu bạn đồng ý tham gia buổi gặp, điều đó đồng nghĩa với việc bạn chấp thuận cho bác sĩ cung cấp thông tin rằng bạn là “đối tượng cần được tư vấn y tế” tới người phụ trách xử lý thông tin hành chính, và chấp thuận nội dung báo cáo cần thiết phục vụ cho mục đích này. Tuy nhiên, nội dung cụ thể của buổi tư vấn sẽ luôn được giữ bí mật tuyệt đối, trừ khi có sự đồng thuận rõ ràng từ bạn. Xin hãy yên tâm."
    );
  }, []);

  useEffect(() => {
    if (
      sendFullStressNotificationData &&
      sendFullStressNotificationData.status === httpStatus.StatusOK
    ) {
      handleConfirmMessage();
    } else if (sendFullStressNotificationError) {
      handleFailMessage();
    }
  }, [sendFullStressNotificationData, sendFullStressNotificationError]);

  useEffect(() => {
    if (
      sendMiniStressNotificationData &&
      sendMiniStressNotificationData.status === httpStatus.StatusOK
    ) {
      handleConfirmMessage();
    } else if (sendMiniStressNotificationError) {
      handleFailMessage();
    }
  }, [sendMiniStressNotificationData, sendMiniStressNotificationError]);

  useEffect(() => {
    if (
      sendHighStressNotificationData &&
      sendHighStressNotificationData.status === httpStatus.StatusOK
    ) {
      handleConfirmMessage();
    } else if (sendHighStressNotificationError) {
      handleFailMessage();
    }
  }, [sendHighStressNotificationData, sendHighStressNotificationError]);

  const SuccessModal = () => (
    <ConfirmModalStyled
      type="form"
      title=""
      visible={isVisibleNotification.status}
      onCancel={() => {
        handleCancelNotication();
      }}
    >
      <div style={{ textAlign: "center", marginTop: 24 }}>
        <ConfirmSuccessIcon />
        <Text
          size={36}
          lnHeight="36px"
          weight={700}
          color="#2ac769"
          mg="20px 0px 24px"
        >
          {t("send-completely")}
        </Text>
        <Text size={16} lnHeight="24px" weight={400}>
          {t("the-transmission-completed")}
        </Text>
        <Text size={16} lnHeight="24px" weight={400} mg="0px 0px 24px">
          {t("close-window")}
        </Text>
        <ConfirmBtnStyled
          background="#E0E0E0"
          color="#FFFFFF"
          padding="11px 96px 13px"
          name={t("close-up")}
          border="none"
          bdr="6px"
          fontSize={16}
          lineHeight="16px"
          onClick={handleCancelNotication}
        />
      </div>
    </ConfirmModalStyled>
  );

  const FailureModal = () => (
    <ConfirmModalStyled
      type="form"
      title=""
      visible={isVisibleNotification.status}
      onCancel={handleCancelNotication}
    >
      <div style={{ textAlign: "center", marginTop: 24 }}>
        <ConfirmFailIcon />
        <Text
          size={36}
          lnHeight="36px"
          weight={700}
          color="#fb4e4e"
          mg="20px 0px 24px"
        >
          {t("transmission-failure")}
        </Text>
        <FailText size={16} lnHeight="24px" weight={400}>
          {t("failed-to-send-the-message")}
        </FailText>
        <FailText size={16} lnHeight="24px" weight={400} mg="0px 0px 24px">
          {t("close-window-contact-support")}
        </FailText>
        <ConfirmBtnStyled
          background="#E0E0E0"
          color="#FFFFFF"
          padding="11px 96px 13px"
          name={t("close-up")}
          border="none"
          bdr="6px"
          fontSize={16}
          lineHeight="16px"
          onClick={handleCancelNotication}
        />
      </div>
    </ConfirmModalStyled>
  );

  const renderNotificationModal = () => {
    if (isVisibleNotification.type === "success") {
      return <SuccessModal />;
    }
    return <FailureModal />;
  };

  const renderSendMessageModal = () => {
    if (isSendAll) {
      return (
        <ConfirmModal
          isVisible={isSendAll}
          close={() => {
            setIsRemindAll(false);
            handleCancel();
          }}
          ok={onSendStressReminder}
        >
          <div>{t2("stress-reminder-notice")}</div>
        </ConfirmModal>
      );
    }

    return (
      <SendMessageModalStyled
        type="form"
        title={label}
        visible={isVisible}
        onCancel={() => {
          handleCancelSendMessageModal();
        }}
      >
        <form
          onSubmit={handleSubmit(() => {
            if (isHighStress) {
              onSendHighStressNotification();
            } else {
              onSendStressReminder();
            }
          })}
        >
          {isHighStress && (
            <SectionContainer>
              <Label>{t("address")}</Label>
              <TagsContainer>
                <BadgeContainer>
                  {checkBoxList?.map((uif: any) => {
                    return (
                      <div key={uif.user_id}>
                        <p>{uif.full_name}</p>
                        <CloseIcon
                          fill="#3B3B3B"
                          onClick={() => {
                            setCheckBoxList(
                              checkBoxList.filter(
                                (item: any) => item.user_id !== uif.user_id
                              )
                            );
                          }}
                        />
                      </div>
                    );
                  })}
                </BadgeContainer>
              </TagsContainer>
            </SectionContainer>
          )}
          <Controller
            control={control}
            name="message_title"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Input
                label={
                  <Label>
                    {t("subject")}
                    <span style={{ color: "#EB5757", marginLeft: 5 }}>*</span>
                  </Label>
                }
                height={54}
                fw={700}
                fsLabel={16}
                fwLabel={700}
                marginForm="0 0 16px"
                lhLabel="22px"
                bdr={12}
                value={value}
                onChange={onChange}
                error={t(error?.message)}
              />
            )}
          />
          {isHighStress && (
            <Controller
              control={control}
              name="message"
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextArea
                  onChange={onChange}
                  error={t(error?.message)}
                  height="248px"
                  fsLabel={16}
                  fwLabel={700}
                  lhLabel="22px"
                  marginForm="0 0 16px"
                  label={
                    <Label>
                      {t("message")}
                      <span style={{ color: "#EB5757", marginLeft: 5 }}>*</span>
                    </Label>
                  }
                  value={value}
                />
              )}
            />
          )}

          <WrapperSendMessageBtn>
            <Button
              background="#2AC769"
              color="#FFFFFF"
              name={t("send")}
              border="none"
              bdr="6px"
              fontSize={16}
              fontWeight={700}
              lineHeight="23px"
              // disabled={!checkBoxList.length}
              disabled={
                isLoadingFullStressNoti ||
                isLoadingMiniStressNoti ||
                isLoadingHighStressNoti
              }
            />
          </WrapperSendMessageBtn>
          <WrapperBtnForm>
            <Button
              background="#E0E0E0"
              color="#FFFFFF"
              name={t1("cancel")}
              border="none"
              bdr="6px"
              fontSize={16}
              fontWeight={700}
              lineHeight="16px"
              onClick={(e: any) => {
                e.preventDefault();
                handleCancelSendMessageModal();
              }}
            />
          </WrapperBtnForm>
        </form>
      </SendMessageModalStyled>
    );
  };

  return (
    <>
      {isVisibleNotification.status
        ? renderNotificationModal()
        : renderSendMessageModal()}
    </>
  );
};

export default ConfirmInterviewModal;
